export default __webpack_public_path__ + "static/TSD_Hero_Shopping_Season_2-7c0f85956d6eba42586f13db1a5704bc.jpg";